import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { EntityState } from '@api/models/enums/EntityState';
import { EstablishmentDto } from '@api/models/establishment/EstablishmentDto';
import { establishmentService } from '@api/services/services';

type State = BaseType<EstablishmentDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    nameEn: '',
    note: '',
    state: EntityState.Active,
    contact: {
      name: '',
      lastName: '',
      phone: '',
      email: '',
    },
    address: {
      street: '',
      city: '',
      postalCode: '',
      country: '',
    },
    stateChangeEnabled: true,
  },
};

export const establishmentSlice = baseSlice({
  name: 'establishment',
  initialState,
});

export const selectEstablishmentState = (state: RootState) => state.establishment.state;
export const selectEstablishment = (state: RootState) => state.establishment.data;
export const establishmentActions = establishmentSlice.actions;

export const getEstablishment = (establishmentId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return establishmentService.getById(establishmentId);
  };

  getItem({
    dispatch,
    actions: establishmentActions,
    getData: handleGetData,
  });
};
